<template>
  <transition name="fade">
    <button
      v-if="played"
      key="rewind"
      :class="{'controls-rewind': true, dark: isDark, disabled: !epi || !epi.id}"
      :disabled="!epi || !epi.id"
      aria-label="15 Seconds Backward"
      @click.prevent="rewind"
      @touchstart.prevent="rewind"

    >
      <slot>
        <IconRewind />
      </slot>
    </button>
  </transition>
</template>

<script>
import IconRewind from '../assets/svg/rewind.svg'
import Store from '../store'

export default {
  components: { IconRewind },
  data () { return { store: Store } },
  computed: {
    epi () { return this.store.state.episode },
    isDark () { return this.store.state.isDark },
    played () { return this.store.state.hasPlayed }
  },
  methods: {
    rewind () {
      this.store.rewind()
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';

button {
  background: none;
  border: none;
  cursor: pointer;
  margin: 0 10px 0 0;
  padding: 0;

  &.dark {
    svg {
      fill: $white-000;
    }
  }
  &.disabled {
    background-color: transparent;
    cursor: default;
    svg {
      fill: $grey-300;
    }
    &.dark {
      svg {
        fill: $grey-700;
      }
    }
  }
}
</style>
